import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UnstyledDropdownToggle from 'components/bootstrap_extensions/bs5/unstyled_dropdown_toggle';
import {
  faEdit,
  faEllipsisVertical,
  faFileExport,
  faTrash
} from '@fortawesome/pro-solid-svg-icons';
import CallListExportModal from '../call_lists/export/modal';
import { deleteWithTurboStream } from '../../helpers/prospect_api';

export default function CallListActionDropdown({
  allowExport,
  callListId,
  exportPath,
  pathForCallList,
  templates,
  unlimitedUnlocks
}) {

  const [showExportModal, setShowExportModal] = useState(false);

  const handleRemove = async () => {
    confirm('Are you sure?') && await deleteWithTurboStream(pathForCallList);
  };

  const renderTooltip = props => (
    allowExport ? <React.Fragment /> :
      <Tooltip {...props}>
        {
          unlimitedUnlocks ?
            'Data exports are not available on your current plan. To change plans, contact sales or support.' :
            'This feature is not available during the trial period.'
        }
      </Tooltip>
  );

  return (
    <React.Fragment>
      <Dropdown drop="start">
        <Dropdown.Toggle as={UnstyledDropdownToggle} className="text-muted">
          <FontAwesomeIcon className="clickable px-2 py-1" icon={faEllipsisVertical} tabIndex={0} />
        </Dropdown.Toggle>
        <Dropdown.Menu className="py-0" renderOnMount>
          <OverlayTrigger overlay={renderTooltip} placement="top">
            <span className="d-inline-block w-100">
              <Dropdown.Item
                className="border-top-0"
                disabled={!allowExport}
                onClick={allowExport ? () => setShowExportModal(true) : undefined}
              >
                <FontAwesomeIcon className="me-2" fixedWidth icon={faFileExport} />
                Export List
              </Dropdown.Item>
            </span>
          </OverlayTrigger>
          <Dropdown.Item className="border-bottom-0" data-turbo={false} href={pathForCallList}>
            <FontAwesomeIcon className="me-2" fixedWidth icon={faEdit} />
            Edit List
          </Dropdown.Item>
          <Dropdown.Item className="border-bottom-0" onClick={handleRemove}>
            <FontAwesomeIcon className="me-2" fixedWidth icon={faTrash} />
            Delete List
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <CallListExportModal
        callListId={callListId}
        exportPath={exportPath}
        show={showExportModal}
        templates={templates}
        onHide={() => setShowExportModal(false)}
      />
    </React.Fragment>
  );
}

CallListActionDropdown.propTypes = {
  allowExport: PropTypes.bool.isRequired,
  callListId: PropTypes.number.isRequired,
  exportPath: PropTypes.string.isRequired,
  pathForCallList: PropTypes.string.isRequired,
  templates: PropTypes.array.isRequired,
  unlimitedUnlocks: PropTypes.bool.isRequired
};

